<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">
      <div class="card-body padding-top-0px margin-left-0px padding-right-0px padding-left-0px padding-bottom-0px">

        <div class="modal-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">

          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px" *ngIf="Categories">

            Add New Patient

            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>-->
          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px" *ngIf="Individual">

            Add New Patient

            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>-->
          <div class="card" *ngIf="Categories">
            <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

              Add New Patient

              <button type="button" class="close" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="card-body margin-left-0px">
              <div class="margin-left-zero p-0 margin-top-20px">
                <div class="card height-100pe">


                  <div class="" *ngIf="Categories">
                    <!--<div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="offset-md-1 col">
                          <label class="radio-inline">

                            Individual<a class="nav-link-hand margin-left-5px" (click)="individual1()"> <input type="radio"> </a>
                          </label>
                        </div>
                        <div class="col">
                          <label class="radio-inline">

                            Donor<a class="nav-link-hand margin-left-5px" (click)="donor()"> <input type="radio"> </a>
                          </label>
                        </div>
                        <div class="col">
                          <label class="radio-inline">

                            Couple<a class="nav-link-hand margin-left-5px" (click)="couple()"> <input type="radio"> </a>
                          </label>
                        </div>


                      </div>

                    </div>-->
                    <div class="patient-type-grid">
                      <!-- 1. Individual Registration -->
                      <div class="patient-type-card-col" (click)="individual1()" *canUserAccess="['HL_REG_3']">
                        <div class="patient-type-card card-individual">
                          <div class="patient-type-icon icon-individual">
                            <i class="fas fa-user"></i>
                          </div>
                          <div>
                            <div class="patient-type-title">Individual</div>
                            <div class="patient-type-desc">Standard Single Patient</div>
                          </div>
                          <span class="patient-type-badge badge-standard">Standard</span>
                        </div>
                      </div>

                      <!-- 2. Donor Registration -->
                      <div class="patient-type-card-col" (click)="donor()" *canUserAccess="['HL_REG_4']">
                        <div class="patient-type-card card-donor">
                          <div class="patient-type-icon icon-donor">
                            <i class="fas fa-hand-holding-heart"></i>
                          </div>
                          <div>
                            <div class="patient-type-title">Donor</div>
                            <div class="patient-type-desc">Egg / Sperm Donor</div>
                          </div>
                          <span class="patient-type-badge badge-standard">ART Donor</span>
                        </div>
                      </div>

                      <!-- 3. Couple Registration -->
                      <div class="patient-type-card-col" (click)="couple()" *canUserAccess="['HL_REG_5']">
                        <div class="patient-type-card card-couple">
                          <div class="patient-type-icon icon-couple">
                            <i class="fas fa-user-friends"></i>
                          </div>
                          <div>
                            <div class="patient-type-title">Couple</div>
                            <div class="patient-type-desc">Joint Partner Registration</div>
                          </div>
                          <span class="patient-type-badge badge-standard">IVF Couple</span>
                        </div>
                      </div>

                      <!-- 4. Aadhaar Registry (India) -->
                      <div class="patient-type-card-col" (click)="aadhaar()">
                        <div class="patient-type-card card-aadhaar">
                          <div class="patient-type-icon icon-aadhaar">
                            <i class="fas fa-fingerprint"></i>
                          </div>
                          <div>
                            <div class="patient-type-title">Aadhaar</div>
                            <div class="patient-type-desc">UIDAI e-KYC Verification</div>
                          </div>
                          <span class="patient-type-badge badge-india-aadhaar">India Registry</span>
                        </div>
                      </div>

                      <!-- 5. ABDM / ABHA Registry (India) -->
                      <div class="patient-type-card-col" (click)="abdm()">
                        <div class="patient-type-card card-abdm">
                          <div class="patient-type-icon icon-abdm">
                            <i class="fas fa-hospital-user"></i>
                          </div>
                          <div>
                            <div class="patient-type-title">ABDM</div>
                            <div class="patient-type-desc">ABHA Health Account</div>
                          </div>
                          <span class="patient-type-badge badge-india-abdm">India Registry</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
            </div>
          </div>
          <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm" *ngIf="Individual">
            <div class="card">
              <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                Add New Patient

                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="card-body padding-bottom-0px">
                <div>

                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="margin-bottom-0px margin-top-3px">
                            <span>*</span>Salutation (Name Prefix)


                          </label>
                        </div>
                        <div class="col-md-3">

                          <!--<input type="text" class="form-control" placeholder="Salutation"
                 id="CurrentSavePatientInfoRequest.Salutation"
                 [(ngModel)]="CurrentSavePatientInfoRequest.Salutation"
                 name="CurrentSavePatientInfoRequest.Salutation" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                 maxlength="20" minlength="1" #Salutation="ngModel" required>
          <small class="form-text text-danger"
                 *ngIf="(!Salutation.valid && (Salutation.dirty || Salutation.touched) && Salutation.errors.required )">(Field cannot be left blank)</small>
          <small class="form-text text-danger"
                 *ngIf="(!Salutation.valid && Salutation.errors.pattern)">(special characters are not allowed)</small>-->

                          <CodeTypeValue CodeType="NPRE" id="CurrentSavePatientInfoRequest.Salutation"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                         name="CurrentSavePatientInfoRequest.Salutation" required>

                          </CodeTypeValue>
                        </div>


                      </div>

                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                        </div>
                        <div class="col-md-3">

                          <input type="text" class="form-control" placeholder="First Name"
                                 id="CurrentSavePatientInfoRequest.DisplayName"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                 name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z,._\-?]*$"
                                 maxlength="30" minlength="1" #DisplayName="ngModel" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>

                        </div>

                      </div>

                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                        </div>
                        <div class="col-md-3">
                          <div class="date-form">
                            <input type="text" class="form-control form-control-patient" placeholder="Date Of Birth"
                                   name="dp" [(ngModel)]="DateOfBirth" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d="ngbDatepicker" #DOBin="ngModel">
                            <small class="form-text text-danger"
                                   *ngIf="(!DOBin.valid && (DOBin.dirty || DOBin.touched) && DOBin.errors.required)">(Field cannot be left blank)</small>

                            <a (click)="d.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>

                          </div>
                          <!--<div class="date-form">
            <input class="form-control form-control-patient" placeholder="Wedding Anniversary" [minDate]="minDate" [maxDate]="maxDate"
                   name="dp3" [(ngModel)]="DateOfBirth" ngbDatepicker #d4="ngbDatepicker" #DOBin="ngModel">
            <small class="form-text text-danger"
                   *ngIf="(!DOBin.valid && (DOBin.dirty || DOBin.touched) && DOBin.errors.required)">(Field cannot be left blank)</small>

            <a (click)="d4.toggle()" class="nav-link-hand">
              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

            </a>

          </div>-->
                        </div>


                      </div>
                    </div>

                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Sex</label>
                        </div>

                        <div class="col-md-3">
                          <CodeTypeValue CodeType="Sex"
                                         id="CurrentSavePatientInfoRequest.Gender"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Gender" SelectedValue=""
                                         name="CurrentSavePatientInfoRequest.Gender" required>
                          </CodeTypeValue>

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number </label>
                        </div>
                        <div class="col-md-3">
                          <!--<input type="tel" class="form-control" placeholder="Mobile Phone"
                 id="CurrentSavePatientInfoRequest.Telephone1"
                 [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                 mask="(000) 000-0000"
                 name="CurrentSavePatientInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
          <small class="form-text text-danger"
                 *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->
                          <input type="tel" class="form-control" placeholder="Mobile Phone"
                                 id="CurrentSavePatientInfoRequest.Telephone1"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                 name="CurrentSavePatientInfoRequest.Telephone1"
                                 maxlength="25" minlength="1" #Telephone1="ngModel">
                        </div>
                      </div>


                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                        </div>
                        <div class="col-md-3">
                          <!--<input type="text" class="form-control" placeholder="Address Line1"
                 id="CurrentSavePatientInfoRequest.AddressLine1"
                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                 maxlength="100">
          <small class="form-text text-danger"
                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                    name="CurrentSavePatientInfoRequest.AddressLine1"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                    #addconcerns_text1="ngModel"></textarea>
                          <small class="form-text text-danger"
                                 *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>
                        </div>
                        <div class="col-md-3">
                          <!--<input type="text" class="form-control" placeholder="Address Line1"
                 id="CurrentSavePatientInfoRequest.AddressLine1"
                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                 maxlength="100">
          <small class="form-text text-danger"
                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line2"
                                    name="CurrentSavePatientInfoRequest.AddressLine2"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine2" minlength="1" maxlength="100"
                                    #addconcerns_text2="ngModel"></textarea>
                          <small class="form-text text-danger"
                                 *ngIf="(!addconcerns_text2.valid && (addconcerns_text2.dirty || addconcerns_text2.touched))"></small>
                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px">Country</label>
                        </div>

                        <div class="col-md-3">
                          <CodeTypeValue CodeType="CNTR"
                                         id="CurrentSavePatientInfoRequest.County"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.County"
                                         name="CurrentSavePatientInfoRequest.County"
                                         (keyChange)="Country($event)"></CodeTypeValue>

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px">State</label>
                        </div>

                        <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                          <CodeTypeValue CodeType="State"
                                         id="CurrentSavePatientInfoRequest.State"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.State"
                                         name="CurrentSavePatientInfoRequest.State"></CodeTypeValue>

                        </div>
                        <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                          <input type="text" class="form-control" placeholder="State"
                                 id="CurrentSavePatientInfoRequest.State"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.State"
                                 name="CurrentSavePatientInfoRequest.State" pattern="^[\sa-zA-Z0-9,._\-?]*$" #State="ngModel"
                                 maxlength="100" />
                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row" *canUserAccess="['HL_REG_CITYMandatory']">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px"><span>*</span> City</label>
                        </div>

                        <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                          <CodeTypeValue CodeType="City"
                                         id="CurrentSavePatientInfoRequest.City"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.City" #City="ngModel"
                                         name="CurrentSavePatientInfoRequest.City" required></CodeTypeValue>
                          <small class="form-text text-danger"
                                 *ngIf="(!City.valid && (City.dirty || City.touched))">(Required)</small>
                        </div>
                        <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                          <input type="text" class="form-control" placeholder="City"
                                 id="CurrentSavePatientInfoRequest.City"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                 name="CurrentSavePatientInfoRequest.City" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel"
                                 maxlength="100" required />
                          <small class="form-text text-danger"
                                 *ngIf="(!City.valid && (City.dirty || City.touched))">(Required)</small>
                        </div>
                      </div>

                      <div class="row" *canUserAccess="['HL_REG_CITYNotMandatory']">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px">City</label>
                        </div>

                        <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                          <CodeTypeValue CodeType="City"
                                         id="CurrentSavePatientInfoRequest.City"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                         name="CurrentSavePatientInfoRequest.City"></CodeTypeValue>

                        </div>
                        <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                          <input type="text" class="form-control" placeholder="City"
                                 id="CurrentSavePatientInfoRequest.City"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                 name="CurrentSavePatientInfoRequest.City" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel"
                                 maxlength="100" />
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row my-profile-form margin-bottom-5px">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-5 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px">Zip Code</label>
                        </div>

                        <div class="col-md-3">
                          <input type="text" class="form-control" placeholder="Zip Code"
                                 id="CurrentSavePatientInfoRequest.ZipCode"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.ZipCode"
                                 name="CurrentSavePatientInfoRequest.ZipCode" #ZipCode="ngModel"
                                 maxlength="6" pattern="[0-9]{6}">
                          <small class="form-text text-danger"
                                 *ngIf="(!ZipCode.valid && (ZipCode.dirty || ZipCode.touched) && ZipCode.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!ZipCode.valid && ZipCode.errors.pattern)">(only numbers are allowed)</small>

                        </div>
                      </div>


                    </div>
                  </div>

                  <!--<div class="row">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
      <div class="row">
        <div class="col-md-3 text-align-right">
          <label for="diaplayName">State </label>
        </div>
        <div class="col-md-3">
          <CodeTypeValue CodeType="State"
                         id="CurrentSavePatientInfoRequest.State"
                         [(ngModel)]="CurrentSavePatientInfoRequest.State"
                         name="CurrentSavePatientInfoRequest.State"></CodeTypeValue>
        </div>
      </div>


    </div>
  </div>-->


                </div>
              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="backtolist()">Back</button>
                <button type="submit" *ngIf='isvisible'
                        [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
              </div>
            </div>
          </form>
          <form class="form" novalidate="" (ngSubmit)="onDonor()" #f="ngForm" *ngIf="Donor">
            <div class="card">
              <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                Add New Donor

                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="card-body padding-bottom-0px">
                <div class="row my-profile-form">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Donor Type</label>
                      </div>

                      <div class="col-md-3">
                        <CodeTypeValue CodeType="DONTY"
                                       id="CurrentSavePatientInfoRequest.DonorTypeName"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.DonorTypeName" SelectedValue=""
                                       name="CurrentSavePatientInfoRequest.DonorTypeName" required>
                        </CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="firstName" class="margin-bottom-0px margin-top-3px">
                          <span>*</span>Salutation (Name Prefix)


                        </label>
                      </div>
                      <div class="col-md-3">

                        <!--<input type="text" class="form-control" placeholder="Salutation"
                 id="CurrentSavePatientInfoRequest.Salutation"
                 [(ngModel)]="CurrentSavePatientInfoRequest.Salutation"
                 name="CurrentSavePatientInfoRequest.Salutation" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                 maxlength="20" minlength="1" #Salutation="ngModel" required>
          <small class="form-text text-danger"
                 *ngIf="(!Salutation.valid && (Salutation.dirty || Salutation.touched) && Salutation.errors.required )">(Field cannot be left blank)</small>
          <small class="form-text text-danger"
                 *ngIf="(!Salutation.valid && Salutation.errors.pattern)">(special characters are not allowed)</small>-->
                        <CodeTypeValue CodeType="NPRE"
                                       id="CurrentSavePatientInfoRequest.Salutation"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                       name="CurrentSavePatientInfoRequest.Salutation" required>
                        </CodeTypeValue>

                      </div>


                    </div>

                  </div>
                </div>
                <div class="row my-profile-form">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                      </div>
                      <div class="col-md-3">

                        <input type="text" class="form-control" placeholder="First Name"
                               id="CurrentSavePatientInfoRequest.DisplayName"
                               [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                               name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                               maxlength="30" minlength="1" #DisplayName="ngModel" required>
                        <small class="form-text text-danger"
                               *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>

                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                      </div>
                      <div class="col-md-3">
                        <div class="date-form">
                          <input class="form-control form-control-patient" placeholder="Date Of Birth"
                                 name="dp" [(ngModel)]="DateOfBirth" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d="ngbDatepicker" #DOB="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                          <a (click)="d.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>
                      </div>


                    </div>
                  </div>

                </div>
                <!--<div class="row my-profile-form">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
      <div class="row">
        <div class="col-md-5 text-align-right">
          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Sex</label>
        </div>

        <div class="col-md-3">
          <CodeTypeValue CodeType="Sex"
                         id="CurrentSavePatientInfoRequest.Gender"
                         [(ngModel)]="CurrentSavePatientInfoRequest.Gender" SelectedValue=""
                         name="CurrentSavePatientInfoRequest.Gender">
          </CodeTypeValue>

        </div>
      </div>


    </div>
  </div>-->
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number </label>
                      </div>
                      <div class="col-md-3">
                        <!--<input type="tel" class="form-control" placeholder="Mobile Phone"
                 id="CurrentSavePatientInfoRequest.Telephone1"
                 [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                 mask="(000) 000-0000"
                 name="CurrentSavePatientInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
          <small class="form-text text-danger"
                 *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->
                        <input type="tel" class="form-control" placeholder="Mobile Phone"
                               id="CurrentSavePatientInfoRequest.Telephone1"
                               [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                               name="CurrentSavePatientInfoRequest.Telephone1"
                               maxlength="25" minlength="1" #Telephone1="ngModel">
                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-3px">Address</label>
                      </div>
                      <div class="col-md-3">
                        <!--<input type="text" class="form-control" placeholder="Address Line1"
                 id="CurrentSavePatientInfoRequest.AddressLine1"
                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                 maxlength="100">
          <small class="form-text text-danger"
                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                  name="CurrentSavePatientInfoRequest.AddressLine1"
                                  [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                  #addconcerns_text1="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>
                      </div>
                      <div class="col-md-3">
                        <!--<input type="text" class="form-control" placeholder="Address Line1"
                 id="CurrentSavePatientInfoRequest.AddressLine1"
                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                 maxlength="100">
          <small class="form-text text-danger"
                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line2"
                                  name="CurrentSavePatientInfoRequest.AddressLine2"
                                  [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine2" minlength="1" maxlength="100"
                                  #addconcerns_text2="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text2.valid && (addconcerns_text2.dirty || addconcerns_text2.touched))"></small>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row my-profile-form">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px">Country</label>
                      </div>

                      <div class="col-md-3">
                        <CodeTypeValue CodeType="CNTR"
                                       id="CurrentSavePatientInfoRequest.County"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.County"
                                       name="CurrentSavePatientInfoRequest.County"
                                       (keyChange)="Country($event)"></CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row my-profile-form">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px">State</label>
                      </div>

                      <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                        <CodeTypeValue CodeType="State"
                                       id="CurrentSavePatientInfoRequest.State"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.State"
                                       name="CurrentSavePatientInfoRequest.State"></CodeTypeValue>

                      </div>
                      <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                        <input type="text" class="form-control" placeholder="State"
                               id="CurrentSavePatientInfoRequest.State"
                               [(ngModel)]="CurrentSavePatientInfoRequest.State"
                               name="CurrentSavePatientInfoRequest.State" pattern="^[\sa-zA-Z0-9,._\-?]*$" #State="ngModel"
                               maxlength="100" />
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row my-profile-form">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">                    
                    <div class="row" *canUserAccess="['HL_REG_CITYMandatory']">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px"><span>*</span> City</label>
                      </div>

                      <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                        <CodeTypeValue CodeType="City"
                                       id="CurrentSavePatientInfoRequest.City"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.City" #City="ngModel"
                                       name="CurrentSavePatientInfoRequest.City" required></CodeTypeValue>
                        <small class="form-text text-danger"
                               *ngIf="(!City.valid && (City.dirty || City.touched))">(Required)</small>
                      </div>
                      <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                        <input type="text" class="form-control" placeholder="City"
                               id="CurrentSavePatientInfoRequest.City"
                               [(ngModel)]="CurrentSavePatientInfoRequest.City"
                               name="CurrentSavePatientInfoRequest.City" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel"
                               maxlength="100" required />
                        <small class="form-text text-danger"
                               *ngIf="(!City.valid && (City.dirty || City.touched))">(Required)</small>
                      </div>
                    </div>

                    <div class="row" *canUserAccess="['HL_REG_CITYNotMandatory']">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px">City</label>
                      </div>

                      <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                        <CodeTypeValue CodeType="City"
                                       id="CurrentSavePatientInfoRequest.City"
                                       [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                       name="CurrentSavePatientInfoRequest.City"></CodeTypeValue>

                      </div>
                      <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                        <input type="text" class="form-control" placeholder="City"
                               id="CurrentSavePatientInfoRequest.City"
                               [(ngModel)]="CurrentSavePatientInfoRequest.City"
                               name="CurrentSavePatientInfoRequest.City" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel"
                               maxlength="100" />
                      </div>
                    </div>

                  </div>
                </div>


                <div class="row my-profile-form margin-bottom-5px">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px">Zip Code</label>
                      </div>

                      <div class="col-md-3">
                        <input type="text" class="form-control" placeholder="Zip Code"
                               id="CurrentSavePatientInfoRequest.ZipCode"
                               [(ngModel)]="CurrentSavePatientInfoRequest.ZipCode"
                               name="CurrentSavePatientInfoRequest.ZipCode" #ZipCode="ngModel"
                               maxlength="6" pattern="[0-9]{6}">
                        <small class="form-text text-danger"
                               *ngIf="(!ZipCode.valid && (ZipCode.dirty || ZipCode.touched) && ZipCode.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!ZipCode.valid && ZipCode.errors.pattern)">(only numbers are allowed)</small>

                      </div>
                    </div>


                  </div>
                </div>

              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="backtolist()">Back</button>
                <button type="submit" *ngIf='isvisible'
                        [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
              </div>
            </div>
          </form>
          <form class="form" novalidate="" (ngSubmit)="onCouple()" #f="ngForm" *ngIf="Couple">
            <div class="card top-link">
              <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                Add New Couple

                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="card-body margin-left-0px padding-top-0px">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-4 border-rt padding-left-0px">
                      <div class="card">
                        <div class="card-header wh-header color-female-heading padding-right-0px ">
                          Female Registration
                        </div>

                      </div>


                      <!--<div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-6 text-align-right">
              <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" placeholder="Address Line1"
                     id="CurrentSavePatientInfoRequest.AddressLine1"
                     [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                     name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                     maxlength="100">
              <small class="form-text text-danger"
                     *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>
            </div>
          </div>


        </div>
      </div>-->

                    </div>
                    <!--<label>Male</label>-->
                    <div class="col-md-4 padding-left-0px">
                      <div class="card">
                        <div class="card-header wh-header color-male-heading">
                          Male Registration
                        </div>

                      </div>


                      <!--<div class="row">
        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
          <div class="row">
            <div class="col-md-6 text-align-right">
              <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" placeholder="Address Line1"
                     id="CurrentSavePatientInfoRequest.AddressLine1"
                     [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                     name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                     maxlength="100">
              <small class="form-text text-danger"
                     *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>
            </div>
          </div>


        </div>
      </div>-->

                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row margin-top-5px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                    <span>*</span>Salutation (Name Prefix)


                                  </label>
                                </div>



                              </div>

                            </div>
                          </div>
                          <div class="row my-profile-form margin-top-10">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                </div>


                              </div>

                            </div>
                          </div>
                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                </div>



                              </div>
                            </div>

                          </div>
                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number  </label>
                                </div>



                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-12">

                                  <CodeTypeValue CodeType="FSAL"
                                                 id="CurrentSavePatientInfoRequest.Salutation"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                                 name="CurrentSavePatientInfoRequest.Salutation" required>
                                  </CodeTypeValue>


                                </div>


                              </div>

                            </div>
                          </div>
                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <input type="text" class="form-control" placeholder="First Name"
                                         id="CurrentSavePatientInfoRequest.DisplayName"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                         name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z,._\-?]*$"
                                         maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>



                                </div>


                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <div class="date-form">
                                    <input class="form-control form-control-patient" placeholder="Date Of Birth"
                                           name="dps" [(ngModel)]="FemaleDateofBirth" ngbDatepicker [minDate]="{year: 1900, month: 1, day: 1}" required #d1fe="ngbDatepicker" #DOBfe="ngModel">
                                    <small class="form-text text-danger"
                                           *ngIf="(!DOBfe.valid && (DOBfe.dirty || DOBfe.touched) && DOBfe.errors.required)">(Field cannot be left blank)</small>

                                    <a (click)="d1fe.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>
                                </div>



                              </div>
                            </div>

                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <!--<input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.Telephone1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                         mask="(000) 000-0000"
                                         name="CurrentSavePatientInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone2="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Telephone2.valid)">(Provide Valid CellNo)</small>-->
                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.Telephone1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                         name="CurrentSavePatientInfoRequest.Telephone1"
                                         maxlength="25" minlength="1" #Telephone2="ngModel">
                                </div>



                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-12">

                                  <CodeTypeValue CodeType="MSAL"
                                                 id="CurrentSavePatientInfoRequest.SalutationMale"
                                                 [(ngModel)]="CurrentSavePatientInfoRequest.SalutationMale" SelectedValue=""
                                                 name="CurrentSavePatientInfoRequest.SalutationMale" required>
                                  </CodeTypeValue>



                                </div>


                              </div>

                            </div>
                          </div>
                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12">
                                  <input type="text" class="form-control" placeholder="First Name"
                                         id="CurrentSavePatientInfoRequest.DisplayNameMale"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.DisplayNameMale"
                                         name="CurrentSavePatientInfoRequest.DisplayNameMale" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>



                                </div>


                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <div class="date-form">
                                    <input class="form-control form-control-patient" placeholder="Date Of Birth"
                                           name="dp2ma" [(ngModel)]="DateOfBirth" ngbDatepicker #d2ma="ngbDatepicker" [minDate]="{year: 1900, month: 1, day: 1}" #DOBma="ngModel" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!DOBma.valid && (DOBma.dirty || DOBma.touched) && DOBma.errors.required)">(Field cannot be left blank)</small>

                                    <a (click)="d2ma.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>
                                </div>



                              </div>
                            </div>

                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <!--<input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.MaleTelephone1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.MaleTelephone1"
                                         mask="(000) 000-0000"
                                         name="CurrentSavePatientInfoRequest.MaleTelephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->
                                  <input type="tel" class="form-control" placeholder="Mobile Phone"
                                         id="CurrentSavePatientInfoRequest.MaleTelephone1"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.MaleTelephone1"
                                         name="CurrentSavePatientInfoRequest.MaleTelephone1"
                                         maxlength="25" minlength="1" #Telephone1="ngModel">
                                </div>



                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row margin-top-10 background-pay">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                      <div class="row margin-top-10 margin-left-0px">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                        </div>
                        <div class="col-md-4">
                          <!--<input type="text" class="form-control" placeholder="Address Line1"
                 id="CurrentSavePatientInfoRequest.AddressLine1"
                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                 maxlength="100">
          <small class="form-text text-danger"
                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                    name="CurrentSavePatientInfoRequest.AddressLine1"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" minlength="1" maxlength="100"
                                    #addconcerns_text1="ngModel"></textarea>
                          <small class="form-text text-danger"
                                 *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))"></small>
                        </div>
                        <div class="col-md-4">
                          <!--<input type="text" class="form-control" placeholder="Address Line1"
                 id="CurrentSavePatientInfoRequest.AddressLine1"
                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                 maxlength="100">
          <small class="form-text text-danger"
                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line2"
                                    name="CurrentSavePatientInfoRequest.AddressLine2"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine2" minlength="1" maxlength="100"
                                    #addconcerns_text2="ngModel"></textarea>
                          <small class="form-text text-danger"
                                 *ngIf="(!addconcerns_text2.valid && (addconcerns_text2.dirty || addconcerns_text2.touched))"></small>
                        </div>

                      </div>


                    </div>
                  </div>
                  <div class="row background-pay">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName">Country </label>
                        </div>
                        <div class="col-md-3">
                          <CodeTypeValue CodeType="CNTR"
                                         id="CurrentSavePatientInfoRequest.County"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.County"
                                         name="CurrentSavePatientInfoRequest.County"
                                         (keyChange)="Country($event)"></CodeTypeValue>
                          <!--id="CurrentActorPersonalDetailInfoRequest.City"
           [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
           name="CurrentActorPersonalDetailInfoRequest.City"
            maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
    <small class="form-text text-danger"
           *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                        </div>
                        <div class="col-md-2 text-align-right">
                          <label for="diaplayName" class="margin-bottom-0px margin-top-3px">State </label>
                        </div>
                        <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                          <CodeTypeValue CodeType="State"
                                         id="CurrentSavePatientInfoRequest.State"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.State"
                                         name="CurrentSavePatientInfoRequest.State"></CodeTypeValue>

                        </div>
                        <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                          <input type="text" class="form-control" placeholder="State"
                                 id="CurrentSavePatientInfoRequest.State"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.State"
                                 name="CurrentSavePatientInfoRequest.State" pattern="^[\sa-zA-Z0-9,._\-?]*$" #State="ngModel"
                                 maxlength="100" />
                        </div>
                      </div>


                    </div>
                  </div>

                  <!--<div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName">State </label>
                        </div>
                        <div class="col-md-3">
                          <CodeTypeValue CodeType="State"
                                         id="CurrentSavePatientInfoRequest.State"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.State"
                                         name="CurrentSavePatientInfoRequest.State"></CodeTypeValue>
                        </div>
                      </div>


                    </div>
                  </div>-->
                  <div class="row background-pay">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      
                      <div class="row" *canUserAccess="['HL_REG_CITYMandatory']">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName"><span>*</span> City </label>
                        </div>
                        <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                          <CodeTypeValue CodeType="City"
                                         id="CurrentSavePatientInfoRequest.City"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.City" #City="ngModel"
                                         name="CurrentSavePatientInfoRequest.City" required></CodeTypeValue>
                          <small class="form-text text-danger"
                                 *ngIf="(!City.valid && (City.dirty || City.touched))">(Required)</small>
                        </div>
                        <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                          <input type="text" class="form-control" placeholder="City"
                                 id="CurrentSavePatientInfoRequest.City"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                 name="CurrentSavePatientInfoRequest.City" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel"
                                 maxlength="100" required />
                          <small class="form-text text-danger"
                                 *ngIf="(!City.valid && (City.dirty || City.touched))">(Required)</small>
                        </div>

                        <div class="col-md-2 text-align-right">
                          <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Zip Code</label>
                        </div>
                        <div class="col-md-3">
                          <input type="text" class="form-control" placeholder="Zip Code"
                                 id="CurrentSavePatientInfoRequest.ZipCode"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.ZipCode"
                                 name="CurrentSavePatientInfoRequest.ZipCode" #ZipCode="ngModel"
                                 maxlength="6" pattern="[0-9]{6}">
                          <small class="form-text text-danger"
                                 *ngIf="(!ZipCode.valid && (ZipCode.dirty || ZipCode.touched) && ZipCode.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!ZipCode.valid && ZipCode.errors.pattern)">(only numbers are allowed)</small>
                          <!--<input class="form-control" type="number" id="username" name="username" maxlength="6" >-->
                        </div>
                      </div>
                      <div class="row" *canUserAccess="['HL_REG_CITYNotMandatory']">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName">City </label>
                        </div>
                        <div class="col-md-3" *ngIf="CountryName == 'INDIA'">
                          <CodeTypeValue CodeType="City"
                                         id="CurrentSavePatientInfoRequest.City"
                                         [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                         name="CurrentSavePatientInfoRequest.City"></CodeTypeValue>

                        </div>
                        <div class="col-md-3" *ngIf="CountryName != 'INDIA'">
                          <input type="text" class="form-control" placeholder="City"
                                 id="CurrentSavePatientInfoRequest.City"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.City"
                                 name="CurrentSavePatientInfoRequest.City" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel"
                                 maxlength="100" />
                        </div>

                        <div class="col-md-2 text-align-right">
                          <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Zip Code</label>
                        </div>
                        <div class="col-md-3">
                          <input type="text" class="form-control" placeholder="Zip Code"
                                 id="CurrentSavePatientInfoRequest.ZipCode"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.ZipCode"
                                 name="CurrentSavePatientInfoRequest.ZipCode" #ZipCode="ngModel"
                                 maxlength="6" pattern="[0-9]{6}">
                          <small class="form-text text-danger"
                                 *ngIf="(!ZipCode.valid && (ZipCode.dirty || ZipCode.touched) && ZipCode.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!ZipCode.valid && ZipCode.errors.pattern)">(only numbers are allowed)</small>
                          <!--<input class="form-control" type="number" id="username" name="username" maxlength="6" >-->
                        </div>
                      </div>

                    </div>
                  </div>
                  <!--<div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                       
                      </div>


                    </div>
                  </div>-->
                  <div class="row background-pay">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                      <div class="row margin-left-0px">
                        <div class=" col-md-3 text-align-right padding-right-0px">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Wedding Anniversary</label>
                        </div>
                        <div class="col-md-3">
                          <!--<input type="text" class="form-control" placeholder="Address Line1"
                 id="CurrentSavePatientInfoRequest.AddressLine1"
                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                 maxlength="100">
          <small class="form-text text-danger"
                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                          <!--<textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                    name="CurrentSavePatientInfoRequest.AddressLine1"
                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" required minlength="1" maxlength="100"
                    #addconcerns_text1="ngModel"></textarea>
          <small class="form-text text-danger"
                 *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>-->
                          <div class="date-form">
                            <input class="form-control form-control-patient" placeholder="Wedding Anniversary" [minDate]="{year: 1900, month: 1, day: 1}"
                                   name="dp3we" [(ngModel)]="WeddingAn" ngbDatepicker #d4we="ngbDatepicker" #DOBwe="ngModel">
                            <small class="form-text text-danger"
                                   *ngIf="(!DOBwe.valid && (DOBwe.dirty || DOBwe.touched) && DOBwe.errors.required)">(Field cannot be left blank)</small>

                            <a (click)="d4we.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>

                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>

              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="backtolist()">Back</button>
                <button type="submit" *ngIf='isvisible'
                        [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
              </div>
            </div>
            <div class="card top-link2">
              <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                Add New Couple

                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="card-body margin-left-0px padding-top-0px">
                <div class="col-md-12 col-12">
                  <div class="row">

                    <div class="col-md-4 col-12 border-rt padding-left-0px">
                      <div class="card">
                        <div class="card-header wh-header color-female-heading padding-right-0px padding-bottom-0px">
                          Female Registration
                        </div>

                      </div>


                      <!--<div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6 text-align-right">
                              <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                            </div>
                            <div class="col-md-6">
                              <input type="text" class="form-control" placeholder="Address Line1"
                                     id="CurrentSavePatientInfoRequest.AddressLine1"
                                     [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                     name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                     maxlength="100">
                              <small class="form-text text-danger"
                                     *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>
                            </div>
                          </div>


                        </div>
                      </div>-->

                    </div>
                    <!--<label>Male</label>-->


                  </div>
                  <div class="row">
                    <div class="col-md-3 col-12">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row margin-top-5px">
                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 col-12 text-align-right">
                                  <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                    <span>*</span>Salutation (Name Prefix)


                                  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">

                                    <div class="col-md-12 col-12">

                                      <CodeTypeValue CodeType="FSAL"
                                                     id="CurrentSavePatientInfoRequest.Salutation"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.Salutation" SelectedValue=""
                                                     name="CurrentSavePatientInfoRequest.Salutation">
                                      </CodeTypeValue>


                                    </div>


                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row my-profile-form margin-top-10">
                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 col-12 text-align-right ">
                                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                </div>


                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 col-12">
                                      <input type="text" class="form-control" placeholder="First Name"
                                             id="CurrentSavePatientInfoRequest.DisplayName"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.DisplayName"
                                             name="CurrentSavePatientInfoRequest.DisplayName" pattern="^[\sa-zA-Z,._\-?]*$"
                                             maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>



                                    </div>


                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 col-12 text-align-right ">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 col-12 text-align-right">
                                      <div class="date-form">
                                        <input class="form-control form-control-patient" placeholder="Date Of Birth" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dps" [(ngModel)]="FemaleDateofBirth" ngbDatepicker #d1="ngbDatepicker" #DOB="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>
                                    </div>



                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>
                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 col-12 text-align-right">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 col-12 text-align-right">
                                      <!--<input type="tel" class="form-control" placeholder="Mobile Phone"
                                             id="CurrentSavePatientInfoRequest.Telephone1"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                             mask="(000) 000-0000"
                                             name="CurrentSavePatientInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->
                                      <input type="tel" class="form-control" placeholder="Mobile Phone"
                                             id="CurrentSavePatientInfoRequest.Telephone1"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.Telephone1"
                                             name="CurrentSavePatientInfoRequest.Telephone1"
                                             maxlength="25" minlength="1" #Telephone1="ngModel">
                                    </div>



                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                  <div class="row">

                    <div class="col-md-4 col-12 border-rt padding-left-0px">
                      <div class="card">
                        <div class="card-header wh-header color-male-heading padding-right-0px padding-bottom-0px">
                          Male Registration
                        </div>

                      </div>


                      <!--<div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6 text-align-right">
                              <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                            </div>
                            <div class="col-md-6">
                              <input type="text" class="form-control" placeholder="Address Line1"
                                     id="CurrentSavePatientInfoRequest.AddressLine1"
                                     [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                     name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                     maxlength="100">
                              <small class="form-text text-danger"
                                     *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>
                            </div>
                          </div>


                        </div>
                      </div>-->

                    </div>
                    <!--<label>Male</label>-->


                  </div>
                  <div class="row">
                    <div class="col-md-3 col-12">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row margin-top-5px">
                            <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 col-12 text-align-right">
                                  <label for="firstName" class="margin-bottom-0px margin-top-3px">
                                    <span>*</span>Salutation (Name Prefix)


                                  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">

                                    <div class="col-md-12">

                                      <CodeTypeValue CodeType="MSAL"
                                                     id="CurrentSavePatientInfoRequest.SalutationMale"
                                                     [(ngModel)]="CurrentSavePatientInfoRequest.SalutationMale" SelectedValue=""
                                                     name="CurrentSavePatientInfoRequest.SalutationMale">
                                      </CodeTypeValue>



                                    </div>


                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row my-profile-form margin-top-10">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Name </label>
                                </div>


                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 col-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <input type="text" class="form-control" placeholder="First Name"
                                             id="CurrentSavePatientInfoRequest.DisplayNameMale"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.DisplayNameMale"
                                             name="CurrentSavePatientInfoRequest.DisplayNameMale" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                             maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>



                                    </div>


                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Date of Birth  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 text-align-right">
                                      <div class="date-form">
                                        <input class="form-control form-control-patient" placeholder="Date Of Birth" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp2" [(ngModel)]="DateOfBirth" ngbDatepicker #d2="ngbDatepicker" #DOB="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                                        <a (click)="d2.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>
                                    </div>



                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>

                          <div class="row margin-top-7px">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-12 text-align-right">
                                  <label for="birthDate" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Contact Number  </label>
                                </div>



                              </div>
                              <div class="row">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-12 text-align-right">
                                      <!--<input type="tel" class="form-control" placeholder="Mobile Phone"
                                             id="CurrentSavePatientInfoRequest.MaleTelephone1"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.MaleTelephone1"
                                             mask="(000) 000-0000"
                                             name="CurrentSavePatientInfoRequest.MaleTelephone1" pattern="[0-9]{10}" #Telephone1="ngModel">
                                      <small class="form-text text-danger"
                                             *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->
                                      <input type="tel" class="form-control" placeholder="Mobile Phone"
                                             id="CurrentSavePatientInfoRequest.MaleTelephone1"
                                             [(ngModel)]="CurrentSavePatientInfoRequest.MaleTelephone1"
                                             name="CurrentSavePatientInfoRequest.MaleTelephone1"
                                             maxlength="25" minlength="1" #Telephone1="ngModel">
                                    </div>



                                  </div>
                                </div>

                              </div>
                            </div>

                          </div>

                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row margin-top-10 background-pay">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                      <div class="row margin-top-10 margin-left-0px">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address</label>
                        </div>
                        <div class="col-md-6">
                          <!--<input type="text" class="form-control" placeholder="Address Line1"
                                 id="CurrentSavePatientInfoRequest.AddressLine1"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                 maxlength="100">
                          <small class="form-text text-danger"
                                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                          <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                    name="CurrentSavePatientInfoRequest.AddressLine1"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"  minlength="1" maxlength="100"
                                    #addconcerns_text1="ngModel"></textarea>
                          <small class="form-text text-danger"
                                 *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))"></small>
                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row background-pay">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px padding-left-0px">
                      <div class="row margin-left-0px">
                        <div class=" col-md-3 text-align-right padding-right-0px">
                          <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Wedding Anniversary</label>
                        </div>
                        <div class="col-md-3">
                          <!--<input type="text" class="form-control" placeholder="Address Line1"
                                 id="CurrentSavePatientInfoRequest.AddressLine1"
                                 [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1"
                                 name="CurrentSavePatientInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                 maxlength="100">
                          <small class="form-text text-danger"
                                 *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>-->
                          <!--<textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                    name="CurrentSavePatientInfoRequest.AddressLine1"
                                    [(ngModel)]="CurrentSavePatientInfoRequest.AddressLine1" required minlength="1" maxlength="100"
                                    #addconcerns_text1="ngModel"></textarea>
                          <small class="form-text text-danger"
                                 *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>-->
                          <div class="date-form">
                            <input class="form-control form-control-patient" placeholder="Wedding Anniversary" [minDate]="minDate" [maxDate]="maxDate"
                                   name="dp3" [(ngModel)]="WeddingAn" ngbDatepicker #d4="ngbDatepicker" #DOB="ngModel">
                            <small class="form-text text-danger"
                                   *ngIf="(!DOB.valid && (DOB.dirty || DOB.touched) && DOB.errors.required)">(Field cannot be left blank)</small>

                            <a (click)="d4.toggle()" class="nav-link-hand">
                              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                            </a>

                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>

              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="backtolist()">Back</button>
                <button type="submit" *ngIf='isvisible'
                        [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-10px">Save</button>
              </div>
            </div>
          </form>

          <!-- Aadhaar Registry Form View -->
          <div class="card" *ngIf="Aadhaar">
            <div class="card-header wh-header padding-bottom-0px border-bottom-1px">
              <div class="d-flex align-items-center justify-content-between width-100pe">
                <div class="d-flex align-items-center">
                  <i class="fas fa-fingerprint text-warning font-size-22px margin-right-10px"></i>
                  <span class="font-weight-600 font-size-17px">Add New Patient — Aadhaar Registry (India)</span>
                </div>
                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="card-body padding-all-20px">
              <div class="registry-notice-box" style="border-left-color: #ff8c00;">
                <div class="d-flex align-items-start">
                  <i class="fas fa-info-circle text-warning font-size-24px margin-right-12px margin-top-2px"></i>
                  <div>
                    <h5 class="font-weight-600 margin-bottom-4px">Aadhaar e-KYC Integration Registry</h5>
                    <p class="margin-bottom-0px text-muted font-size-13px">
                      This option enables importing verified patient demographic details (Name, DOB, Gender, Address) directly from UIDAI e-KYC. Real-time API gateway verification will be linked upon UIDAI gateway credentials pairing.
                    </p>
                  </div>
                </div>
              </div>

              <div class="row padding-top-10px padding-bottom-20px">
                <div class="col-md-12">
                  <div class="row align-items-center">
                    <div class="col-md-4 text-align-right">
                      <label class="font-weight-600 margin-bottom-0px font-size-14px">12-Digit Aadhaar Number</label>
                    </div>
                    <div class="col-md-5">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fas fa-id-card"></i></span>
                        </div>
                        <input type="text" class="form-control" placeholder="XXXX - XXXX - XXXX"
                               [(ngModel)]="AadhaarNumber" name="AadhaarNumber" maxlength="14" />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <button type="button" class="btn btn-outline-warning font-size-13px" disabled>
                        <i class="fas fa-paper-plane margin-right-5px"></i> Send e-KYC OTP
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised float-right" (click)="backtolist()">Back</button>
              <button type="button" class="btn btn-primary font-size-13px float-right margin-right-10px" (click)="individual1()">Continue with Standard Form</button>
            </div>
          </div>

          <!-- ABDM / ABHA Registry Form View -->
          <div class="card" *ngIf="ABDM">
            <div class="card-header wh-header padding-bottom-0px border-bottom-1px">
              <div class="d-flex align-items-center justify-content-between width-100pe">
                <div class="d-flex align-items-center">
                  <i class="fas fa-hospital-user text-info font-size-22px margin-right-10px"></i>
                  <span class="font-weight-600 font-size-17px">Add New Patient — Ayushman Bharat Digital Mission (ABDM)</span>
                </div>
                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="card-body padding-all-20px">
              <div class="registry-notice-box" style="border-left-color: #004e8c;">
                <div class="d-flex align-items-start">
                  <i class="fas fa-notes-medical text-info font-size-24px margin-right-12px margin-top-2px"></i>
                  <div>
                    <h5 class="font-weight-600 margin-bottom-4px">ABHA / ABDM Health ID Registry Module</h5>
                    <p class="margin-bottom-0px text-muted font-size-13px">
                      This option enables linking and pulling national digital health records via Ayushman Bharat Health Account (ABHA). Real-time M1/M2 NDHM gateway pairing will be active upon sandbox credentials pairing.
                    </p>
                  </div>
                </div>
              </div>

              <div class="row padding-top-10px padding-bottom-20px">
                <div class="col-md-12">
                  <div class="row align-items-center">
                    <div class="col-md-4 text-align-right">
                      <label class="font-weight-600 margin-bottom-0px font-size-14px">14-Digit ABHA Number / Address</label>
                    </div>
                    <div class="col-md-5">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fas fa-qrcode"></i></span>
                        </div>
                        <input type="text" class="form-control" placeholder="XX-XXXX-XXXX-XXXX or name@abdm"
                               [(ngModel)]="ABHANumber" name="ABHANumber" maxlength="25" />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <button type="button" class="btn btn-outline-info font-size-13px" disabled>
                        <i class="fas fa-search margin-right-5px"></i> Fetch ABHA Profile
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised float-right" (click)="backtolist()">Back</button>
              <button type="button" class="btn btn-primary font-size-13px float-right margin-right-10px" (click)="individual1()">Continue with Standard Form</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

